import { apiGet, apiPost, apiPut, apiDelete, planningPath } from './PlanningApiClient';
import { Room } from '../types/Planner';

export interface FloorPlanTemplate {
  id: string;
  name: string;
  description: string | null;
  rooms: Omit<Room, 'id'>[];
  scale: number;
  width: number;
  height: number;
}

interface ApiTemplate {
  id: string;
  name: string;
  description: string | null;
  rooms: Omit<Room, 'id'>[];
  scale: number;
  width: number;
  height: number;
}

let templatesCache: FloorPlanTemplate[] | null = null;

export async function loadFloorPlanTemplates(): Promise<FloorPlanTemplate[]> {
  if (templatesCache) return templatesCache;
  const res = await apiGet<{ templates: ApiTemplate[] }>(planningPath('/floor-plan-templates'));
  templatesCache = res.templates;
  return templatesCache;
}

export async function apiCreateFloorPlanTemplate(data: {
  name: string;
  description?: string;
  rooms: Omit<Room, 'id'>[];
  scale: number;
  width: number;
  height: number;
}): Promise<FloorPlanTemplate> {
  const template = await apiPost<ApiTemplate>(planningPath('/floor-plan-templates'), data);
  templatesCache = null;
  return template;
}

export async function apiRenameFloorPlanTemplate(id: string, name: string, description?: string): Promise<void> {
  await apiPut(planningPath(`/floor-plan-templates/${id}`), { name, description });
  templatesCache = null;
}

export async function apiDeleteFloorPlanTemplate(id: string): Promise<void> {
  await apiDelete(planningPath(`/floor-plan-templates/${id}`));
  templatesCache = null;
}
